<template>
  <div class="Model">
    <Modal
      v-model="nextStatus"
      title="查看详情"
      :closable="false"
      :mask-closable="false"
      :footer-hide="true"
    >
     <ul v-if="cronList">
       <li>任务触发类型: {{cronList.taskTriggerType || '--'}}</li>
       <li>调度机器: {{cronList.dispatchMachine || '--'}}</li>
       <li>执行器-注册方式: {{cronList.registerMethod || '--'}}</li>
       <li>执行器-地址列表: {{cronList.addressList || '--'}}</li>
       <li>路由策略： {{cronList.routingStrategy || '--'}}</li>
       <li>阻塞处理策略: {{cronList.blockStrategy || '--'}}</li>
       <li>任务超时时间: {{cronList.taskTimeout || '--'}}</li>
       <li>失败重试次数: {{cronList.failedNumber || '--'}}</li>
       <li>执行器地址: {{cronList.executorAddress || '--'}}</li>
       <li>JobHandler: {{cronList.executorHandler || '--'}}</li>
       <li>任务参数: {{cronList.executorParam || '--'}}</li>
     </ul>
     <p v-else>暂无数据</p>
    <!-- 按钮组 -->
    <div class="btn-box">
      <Button class="ys-confirm" type="primary" @click="ok" style="width: 100px;">确认</Button>
    </div>
    </Modal>
  </div>
</template>
<script>
export default {
  props:{
    nextStatus: {
      type: Boolean,
      default: false
    },
    cronList: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
    }
  },
  methods:{
    ok (name) {
      this.$emit('handle-next-model', {code: 2})
    }
  },
  mounted() {
    console.log(this.cronList)
  }
}
</script>
<style lang="less" scoped>
.btn-box {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;
  margin-top: 40px;
}
</style>